<script>
import Vue from 'vue'
import messages from '../mixins/messages'
import CompanyResource from '../resources/company'
import CompanyPaymentMethodForm from '@/components/CompanyPaymentMethodForm.vue'

export default Vue.extend({
    components: {
        CompanyPaymentMethodForm,
    },
    mixins: [messages],
    props: {
        companyResource: {
            type: CompanyResource,
            required: true,
        },
    },
    data() {
        return {
            type: 'teams',
            loading: false,
        }
    },
    methods: {
        async submitPaymentForm() {
            if (this.$refs.paymentForm.entry) {
                return await this.$refs.paymentForm.submit()
            }

            return true
        },
        async subscribe() {
            this.loading = true

            try {
                if (await this.submitPaymentForm()) {
                    if (this.type === 'teams') {
                        await this.companyResource.subscribeToTeams()
                    } else if (this.type === 'unlimited') {
                        await this.companyResource.subscribeToUnlimited()
                    } else if(this.type === 'prepay') {
                        await this.companyResource.prepayListing()
                    }

                    this.$emit('success', this.type)
                }
            } catch (err) {
                this.addError(this.parseAPIErrorsOrRethrow(err))
            } finally {
                this.loading = false
            }
        },
        teams() {
            this.type = 'teams'
            this.$refs.salesModal.show()
        },
        unlimited() {
            this.type = 'unlimited'
            this.$refs.salesModal.show()
        },
        prepay() {
            this.type = 'prepay'
            this.$refs.salesModal.show()
        },
        hide() {
            this.$refs.salesModal.hide()
        },
        close() {
            this.hide()
        },
    },
})
</script>

<template>
    <div>
        <b-modal ref="salesModal" header-bg-variant="secondary" header-text-variant="light" centered no-fade>

            <template slot="modal-footer">
                <b-row>
                    <b-button :disabled="loading" variant="primary" size="lg" @click="subscribe" class="col-md-8 offset-md-2">
                        <span v-if="type === 'prepay'">Create Listing ($49)</span>
                        <span v-if="['teams', 'unlimited'].includes(type)">Start Free Trial</span>
                    </b-button>
                </b-row>
            </template>
            
            <template slot="modal-title">
                <span v-if="type === 'prepay'">Single Listing</span>
                <span v-if="type === 'teams'">Teams Subscription</span>
                <span v-if="type === 'unlimited'">Unlimited Subscription</span>
            </template>
            
            <div v-if="['teams', 'unlimited'].includes(type)" class="text-center">
                <b-badge class="mr-2" pill>
                    <b-icon icon="patch-check" /> Free 7-Day Trial
                </b-badge>
                <b-badge pill>
                    <span v-if="type === 'teams'">$99/mo thereafter</span>
                    <span v-if="type === 'unlimited'">$399/mo thereafter</span>
                </b-badge>
                <br />
                <small>Your payment method will not be charged at this time. You can cancel your membership within 7 days to avoid charges. If you choose to keep your paid membership, it will start on the 8th day.</small>
                <hr class="mb-4" />
            </div>

            <slot />

            <company-payment-method-form
                :company-resource="companyResource"
                :show-submit="false"
                ref="paymentForm">
            </company-payment-method-form>
        </b-modal>

    </div>
</template>

<style lang="scss">
footer.modal-footer {
    display: block;
}
</style>
